import { render, staticRenderFns } from "./about.vue?vue&type=template&id=54ac2f65&"
import script from "./scripts.js?vue&type=script&lang=js&"
export * from "./scripts.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports